export default "__VITE_ASSET__BWMmu_jT__"